import Flex from 'components/Flex'
import styled from 'styled-components'

export const ColumnHead = styled(Flex)`
  justify-content: space-around;
  gap: 10px;
  width: '100px';
`
